import { ClientKind } from '../../api/enumerations';

export const DASHBOARD_TITLE = 'PAINEL DE CONTROLE';

export const MAX_RECORDS_HINT = 500;

export type PeriodKey = 'today' | 'month' | 'quarter' | 'year';

export const PERIOD_LABEL: Record<PeriodKey, string> = {
  today: 'hoje',
  month: 'mês',
  quarter: 'trimestre',
  year: 'ano',
};

export const PREVIOUS_PERIOD_LABEL: Record<PeriodKey, string> = {
  today: 'ontem',
  month: 'mês anterior',
  quarter: 'trimestre anterior',
  year: 'ano anterior',
};

export const KPI_LABELS = {
  volume: 'volume',
  slaOnTime: 'SLA on-time',
  tmc: 'TMC (dias)',
  rejection: 'taxa de rejeição',
} as const;

export const KPI_HINTS = {
  volume: 'OS criadas no período',
  slaOnTime: 'OS não-atrasadas / total no período',
  tmc: 'tempo médio de ciclo (entrada → arquivado)',
  rejection: 'OS rejeitadas pelo banco / total no período',
} as const;

export const SECTION_TITLES = {
  activity: 'atividade no período',
  trendsAndState: 'últimos 12 meses',
} as const;

export const CHART_TITLES = {
  volume: 'volume de OS criadas por mês (12 meses)',
  statusFunnel: 'OS por status (últimos 12 meses)',
  topCompanies: 'top 10 fornecedores (cor por % atraso)',
  topRegions: 'distribuição por UF (top 8)',
  clientKindDonut: 'distribuição por tipo de cliente',
  reportFunctionBar: 'distribuição por finalidade (top 6)',
  criticalList: 'OS críticas (top 5 atrasadas)',
} as const;

export const STATUS_HINT = 'exibindo até';
export const STATUS_HINT_SUFFIX =
  'OS por janela — refine os filtros para resultados mais precisos';

export const REFRESHING_LABEL = 'atualizando...';

export const CLIENT_KIND_OPTIONS: ClientKind[] = [
  ClientKind.BRASIL_BANK,
  ClientKind.CAIXA,
  ClientKind.BNB,
  ClientKind.ITAU,
  ClientKind.BRADESCO,
  ClientKind.SANTANDER,
  ClientKind.CORPORATE,
  ClientKind.LANDING,
  ClientKind.OTHER_BANK,
];
